<template>
  <h2 class="pb-2 border-bottom">PRP & Microneedling</h2>
  <p>Natural Regeneration for Skin, Hair, and Wellness</p>
  <p>Our PRP (Platelet-Rich Plasma) therapies use your body’s own growth factors to stimulate natural healing and regeneration. Under medical supervision, PRP can support skin rejuvenation, hair restoration, pain relief, and overall wellness — with minimal downtime.”</p>
  <h3>Organized Services</h3>
  <ul>
    <li>PRP for Skin Rejuvenation — stimulates collagen, supports smoother texture, and enhances natural glow.</li>
    <li>PRP for Hair Restoration — strengthens follicles, reduces shedding, and promotes new growth.</li>
    <li>PRP for Joint & Pain Relief — helps with arthritis, tendinitis, and injury recovery by reducing inflammation.</li>
    <li>PRP for Wellness Support — therapies that can complement vitality and confidence (site pode detalhar O-Shot/P-Shot, mas evitar em Ads).</li>
    <li>PRP for Scars — reduces pigmentation and supports smoother skin after acne or injury.</li>
  </ul>
  <h3>Procedure Overview (simplified)</h3>
  <ol>
    <li>Small blood draw</li>
    <li>Separation of PRP through centrifuge</li>
    <li>Application via microneedling or injection</li>
    <li>Quick recovery — mild swelling/redness 24–48h</li>
  </ol>
  <p>PRP therapy combines science and natural healing to restore balance and confidence  safely and effectively.</p>
</template>

<script>
export default {
  name: 'PRPMicroneedlingFacialContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
